import { title } from "assets/jss/material-kit-react.jsx";

const workStyle = {
  section: {
    padding: "30px 0"
  },
  title: {
    ...title,
    marginBottom: "30px",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
    textAlign: "center"
  },
  description: {
    color: "#000000",
    textAlign: "center"
  },
  textCenter: {
    textAlign: "center"
  },
  textArea: {
    marginRight: "15px",
    marginLeft: "15px"
  }
};

export default workStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx